import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import type { ReactNode } from 'react';

interface DetailTableRow {
  label: ReactNode;
  value: ReactNode;
}

type EmptyRow = false | null | undefined | '';

interface Props {
  rows: (DetailTableRow | EmptyRow)[];
  labelWidth?: string;
}

export function DetailTable({ rows, labelWidth = '44%' }: Props) {
  const visibleRows = rows.filter((row): row is DetailTableRow => !!row);

  if (visibleRows.length === 0) {
    return null;
  }

  return (
    <TableContainer
      sx={{
        border: '1px solid',
        borderColor: 'border',
        borderRadius: '0.5rem',
        backgroundColor: 'surface',
        boxShadow: 1,
        overflow: 'hidden',
      }}
    >
      <Table size="small" sx={{ tableLayout: 'fixed', width: '100%' }}>
        <TableBody>
          {visibleRows.map(({ label, value }, index) => (
            <TableRow key={index}>
              <TableCell
                component="th"
                scope="row"
                sx={{
                  width: labelWidth,
                  px: '1rem',
                  py: '0.7rem',
                  borderBottom: index === visibleRows.length - 1 ? 0 : '1px solid',
                  borderBottomColor: 'border',
                  backgroundColor: 'surfaceHover',
                  color: 'text.secondary',
                  fontSize: '0.9rem',
                  fontWeight: 600,
                  lineHeight: 1.35,
                  verticalAlign: 'top',
                }}
              >
                {label}
              </TableCell>
              <TableCell
                sx={{
                  px: '1rem',
                  py: '0.7rem',
                  borderBottom: index === visibleRows.length - 1 ? 0 : '1px solid',
                  borderBottomColor: 'border',
                  color: 'text.primary',
                  fontSize: '0.95rem',
                  lineHeight: 1.35,
                  verticalAlign: 'top',
                }}
              >
                {value}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
